import localUser from '@/utils/local-user';

class AjaxStorage {
  user: any = {};
  cUser: any = {};

  getUser() {
    if (this.user?.sid) return this.user;

    const user = localUser.getQWUser() || {};
    this.user = user;
    return this.user;
  }

  getCUser() {
    if (this.cUser?.sid) return this.cUser;

    const cUser = localUser.getCUser() || {};
    this.cUser = cUser;
    return this.cUser;
  }

}

export default new AjaxStorage();
